// ── Mega menú iPhone ──
(function () {
  'use strict';

  var trigger  = document.getElementById('mega-trigger');
  var menu     = document.getElementById('mega-menu');
  var backdrop = document.getElementById('mega-backdrop');
  var label    = document.getElementById('mega-label-btn');

  if (!trigger || !menu || !backdrop) return;

  var isOpen   = false;
  var hoverTimer;

  function openMenu() {
    clearTimeout(hoverTimer);
    isOpen = true;
    trigger.classList.add('is-open');
    menu.classList.add('is-visible');
    menu.setAttribute('aria-hidden', 'false');
    backdrop.classList.add('is-visible');
    if (label) label.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    isOpen = false;
    trigger.classList.remove('is-open');
    menu.classList.remove('is-visible');
    menu.setAttribute('aria-hidden', 'true');
    backdrop.classList.remove('is-visible');
    if (label) label.setAttribute('aria-expanded', 'false');
  }

  function scheduleClose() {
    hoverTimer = setTimeout(closeMenu, 120);
  }

  // ── Hover ──
  trigger.addEventListener('mouseenter', openMenu);
  trigger.addEventListener('mouseleave', scheduleClose);
  menu.addEventListener('mouseenter', function () { clearTimeout(hoverTimer); });
  menu.addEventListener('mouseleave', scheduleClose);

  // ── Click (para touch y fallback) ──
  if (label) {
    label.addEventListener('click', function (e) {
      // Solo interceptar en desktop — dejar navegar en mobile
      if (window.innerWidth <= 900) return;
      e.preventDefault();
      isOpen ? closeMenu() : openMenu();
    });
  }

  // ── Cerrar con backdrop ──
  backdrop.addEventListener('click', closeMenu);

  // ── Cerrar con Escape ──
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeMenu();
  });

  // ── Ajustar top del mega menú según header height ──
  function syncMenuTop() {
    var header = document.getElementById('site-header');
    if (header && menu) {
      menu.style.top = header.offsetHeight + 'px';
    }
  }
  syncMenuTop();
  window.addEventListener('resize', syncMenuTop);

})();